import { render, staticRenderFns } from "./PreschoolEnglish2.vue?vue&type=template&id=82d55268&scoped=true&"
import script from "./PreschoolEnglish2.vue?vue&type=script&lang=js&"
export * from "./PreschoolEnglish2.vue?vue&type=script&lang=js&"
import style0 from "@/assets/hometeacher/css/main.css?vue&type=style&index=0&lang=css&"
import style1 from "./PreschoolEnglish2.vue?vue&type=style&index=1&id=82d55268&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d55268",
  null
  
)

export default component.exports